const LOCAL_STORAGE_TOKEN_KEY = 'token';

export default {
  getToken: () => localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY),
  setToken: (token: string) =>
    localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token),
  clearToken: () => localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY),
};
